import React from "react";
import { properties } from "config/ClientConfigurations";

export default function FooterSmall(props) {
  return (
    <>
      <footer
        className={
          (props.absolute 
            ? "absolute w-full bottom-0 bg-blueGray-800"
            : "relative") + " pb-6"
        }
      >
        <div className="container mx-auto float-left mt-4">
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-sm text-blueGray-500 font-semibold text-center md:text-left">
                Copyright © {new Date().getFullYear()}{"  "}
                  {properties.companyName} All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
